import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
// mui components
import { Avatar, CircularProgress, Divider, Grid, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
// icons
import CrossIcon from 'assets/icons/buttons/cross.svg';
// helpers
import { getImageBySize } from 'utils/helpers';
// api
// styles
import { fileFeedPostsAtom } from 'atoms';
import { useAtomValue } from 'jotai';
import { useGetProfilesQuery } from 'redux-store/api/profiles';
import { likersListStyles } from '../../../likers/styles/index';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children as any}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 21,
            top: 21,
            cursor: 'pointer',
          }}
        >
          <CrossIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const CommentLikersListModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: profiles, isLoading } = useGetProfilesQuery(undefined);

  const posts = useAtomValue(fileFeedPostsAtom(searchParams.get('fileId') || ''));
  const post = posts.find((p) => p.id === searchParams.get('postId')) || null;

  const handleClose = () => {
    searchParams.delete('fileId');
    searchParams.delete('postId');
    setSearchParams(searchParams);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={Boolean(searchParams.get('fileId') && searchParams.get('postId'))}
        PaperProps={{
          sx: {
            width: '430px',
            borderRadius: '12px',
          },
        }}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Typography sx={likersListStyles.likesText}>Likes</Typography>
          <Typography sx={likersListStyles.membersText}>
            Here is a list of members who liked this post!!!
          </Typography>
        </BootstrapDialogTitle>
        <Divider sx={likersListStyles.divider} />
        <Grid sx={likersListStyles.scrollContainer}>
          {isLoading ? (
            <CircularProgress sx={likersListStyles.circularProgress} />
          ) : post?.likes ? (
            post.likes.map((userId) => {
              const user = profiles?.items.find((u) => u.id?.toString() === userId.toString());
              return (
                <Grid sx={likersListStyles.likerContainer} key={user.id}>
                  <Avatar
                    alt="avatar"
                    sx={likersListStyles.userAvatar}
                    src={getImageBySize(user.avatar, 36, 36)}
                    variant="square"
                  />
                  <Typography
                    sx={likersListStyles.userName}
                  >{`${user.firstName} ${user.lastName}`}</Typography>
                </Grid>
              );
            })
          ) : null}
        </Grid>
      </BootstrapDialog>
    </div>
  );
};

export default CommentLikersListModal;
